import { FC } from "react";
import { BoxProps, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

interface VariantProps {
  gridProps?: Record<string, any>;
  textProps?: Record<string, any>;
  // Add more props as needed
}

const manualVariants: Record<string, VariantProps> = {
  stacked: {
    gridProps: {
      templateColumns: "flex",
      gap: 2,
    },
    textProps: {
      fontWeight: "semibold",
    },
  },
  // Add more variants as needed
};

export const CheckedField: FC<{
  label: string;
  value: boolean;
  manualVariant?: string;
} & BoxProps> = ({
  label,
  value,
  manualVariant,
  ...rest
}) => {

  const variantProps = manualVariant ? manualVariants[manualVariant] : {};

  return (
    <Grid
      templateColumns="repeat(8, 1fr)"
      gap={6}
      mb={4}
      alignItems={"start"}
      {...variantProps.gridProps}
      {...rest}
    >
      <GridItem colSpan={3} {...rest}>
        <Text
          mr={1}
          color={"primary.darker"}
          fontWeight={"bold"}
          fontSize={"sm"}
          {...variantProps.textProps}
        >
          {label}
        </Text>
      </GridItem>
      <GridItem colSpan={5}>
        <Icon
          as={value ? FaCheckCircle : MdCancel}
          width={6}
          height={6}
          color={value ? "green.300" : "error"}
        />
      </GridItem>
    </Grid>
  );
};
